import {SubmitButton} from "components/Button";
import {FormCard} from "components/Form";
import {DashboardLayout} from "components/Layout";
import {CircleLoader} from "components/Loader";
import {useDetailForumCategory} from "hooks/SuperAdmin/ForumCategory";
import {useHistory, useParams} from "react-router-dom";

const MasterForumCategoryDetail = () => {
	const history = useHistory();
	const {id} = useParams();
	const {data: detailForumCategory, isLoading: loadingFetcing} = useDetailForumCategory(id);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar Kategori Forum" title="Detail Kategori Forum">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar Kategori Forum"
				title={`Detail Data Kategori Forum ${detailForumCategory?.data?.title}`}
				onBackButtonClick={() => history.push("/forum-category")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-12 col-lg-6">
						<div class="setting-item">
							<label class="setting-label ">Kategori</label>
							<p className="text-bold text-grey">{detailForumCategory?.data?.title}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/forum-category/edit/${detailForumCategory?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
};

export {MasterForumCategoryDetail};
